module.exports = __webpack_public_path__ + "static/media/OCFL-311-App-Page.1cbb5be5.png";